var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategory2 = function SvgCategory2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16563 6.89984L2.09896 6.89984C1.03229 6.89984 0.498958 7.43317 0.498958 8.49984L0.498958 9.5665C0.498958 10.6332 1.03229 11.1665 2.09896 11.1665L3.16562 11.1665C4.23229 11.1665 4.76563 10.6332 4.76563 9.5665L4.76563 8.49984C4.76563 7.43317 4.23229 6.89984 3.16563 6.89984Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56406 0.499935L8.4974 0.499935C7.43073 0.499935 6.8974 1.03327 6.8974 2.09993L6.8974 3.1666C6.8974 4.23327 7.43073 4.7666 8.4974 4.7666L9.56406 4.7666C10.6307 4.7666 11.1641 4.23327 11.1641 3.1666L11.1641 2.09994C11.1641 1.03327 10.6307 0.499935 9.56406 0.499935Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03073 6.89984C7.85252 6.89984 6.8974 7.85496 6.8974 9.03317C6.8974 10.2114 7.85252 11.1665 9.03073 11.1665C10.2089 11.1665 11.1641 10.2114 11.1641 9.03317C11.1641 7.85496 10.2089 6.89984 9.03073 6.89984Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63229 0.499935C1.45408 0.499935 0.498958 1.45506 0.498958 2.63327C0.498958 3.81148 1.45408 4.7666 2.63229 4.7666C3.8105 4.7666 4.76563 3.81148 4.76563 2.63327C4.76563 1.45506 3.8105 0.499935 2.63229 0.499935Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCategory2;